import { Feature, LineString, Point, Polygon } from 'geojson'
import { S2LatLng, S2CellId, S2Cell } from 'nodes2ts'
import { v5 } from 'uuid'
import config from '@iotv/config'
import { GeofencePointsType } from '../../../types/ModelTypes'
import { GeoJsonDatastoreObject } from '../../../types/GeoTypes'
import { bbox } from '@turf/bbox'
import { DEBUG_OVERRIDE, IS_LAMBDA } from '../../lambda'
import Long from 'long'

const debug = DEBUG_OVERRIDE || (!IS_LAMBDA && false)

export const convertPointLatLngArr = ([lat, lng]: [number, number]) => convertPointLatLngMap({ lat, lng })

export const convertPointLatLngMap = (latLngMap: GeofencePointsType) => {
  const { lat, lng } = latLngMap
  const s2LatLng = S2LatLng.fromDegrees(lat, lng)
  const s2Point = s2LatLng.toPoint()
  const s2cellId = S2CellId.fromPoint(s2Point)
  return s2cellId
}

/** convert Position or Polygon into a level 22 s2CellTokem
 * the defaultLevel is 20 which is approx 10m squarish in medium latitudes
 * the used level for locating a point is therefore 22, which is approx 2m squarish
 */
export const convertLatLngLocationToId = (latLngMap: GeofencePointsType, level: number = config.app.geo.S2.defaultLevel + 2) => {
  return convertPointLatLngMap(latLngMap).parentL(level).toToken()
}

export const getLevelParent = (s2CellId: S2CellId, level: number = config.app.geo.S2.defaultLevel) => s2CellId.parentL(level)

export const getCellIdId = (s2CellId: S2CellId) => s2CellId.id as Long

export const s2CellIdToGeoPointType = (s2CellId: S2CellId) => {
  const parentCellId = getLevelParent(s2CellId)
  const s2CellToken = parentCellId.toToken()
  const parentCell = new S2Cell(parentCellId)
  const feature = parentCell.toGEOJSON() as Feature
  feature.id = s2CellToken
  const geoObjectInstance = createGeoObjectTypeInstance(feature, s2CellToken)
  if (!geoObjectInstance) {
    debug && console.log(`No geopointInstance create with`, { s2CellId })
  } else {
    debug && console.log(`created geopointInstance create with`, { s2CellId, geoObjectInstance })
  }
  return geoObjectInstance
}

export const createGeoObjectTypeInstance = (feature: Feature, s2CellToken?: string): GeoJsonDatastoreObject | undefined => {
  let zombieObject: GeoJsonDatastoreObject | undefined = undefined
  debug && console.log('createInstance', feature)
  const type = s2CellToken ? 'Point' : feature.geometry.type
  switch (type) {
    case 'Point':
      {
        const point = feature as Feature<Point>
        const [lat, lng, z] = point.geometry.coordinates
        const s2CellId = convertPointLatLngArr([lat, lng])
        const s2CellTokenFromLatLng = s2CellId.toToken()
        const id = s2CellToken ?? s2CellTokenFromLatLng
        const sk = `${type}:${id}`,
          pk = sk
        zombieObject = {
          type,
          id,
          sk,
          pk,
          position: s2CellToken ? undefined : { lat, lng },
          bbox: point.bbox ?? bbox(point),
          geoJson: point,
          name: point?.properties?.name,
          description: point?.properties?.description,
        }
      }
      break
    case 'LineString':
      {
        const lineString = feature as Feature<LineString>
        debug && console.log('feature at Linestring', lineString)
        const idHash = lineString.geometry.coordinates.map(([lat, lng]) => `${lat},${lng}`).join('')
        const id = s2CellToken ?? v5(idHash, config.app.namespace_uuid),
          sk = `${type}:${id}`,
          pk = sk
        zombieObject = {
          type,
          id,
          sk,
          pk,
          bbox: lineString.bbox ?? bbox(lineString),
          geoJson: lineString,
          name: lineString?.properties?.name,
          description: lineString?.properties?.description,
        }
      }
      break
    case 'Polygon':
      {
        const polygon = feature as Feature<Polygon>
        const idHash = polygon.geometry.coordinates.map(([lat, lng]) => `${lat},${lng}`).join('')
        const id = s2CellToken ?? v5(idHash, config.app.namespace_uuid)
        const sk = `${type}:${id}`
        zombieObject = {
          type,
          id,
          sk,
          pk: sk,

          bbox: polygon.bbox ?? bbox(polygon),
          geoJson: polygon,
          name: polygon?.properties?.name,
          description: polygon?.properties?.description,
        }
      }
      break
  }
  s2CellIdToGeoPointType
  return zombieObject
}
